import React from 'react';

function scrollTo(id) { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }

const cityLinks = ['LA','Dallas','SF','Hawaii','Louisiana','Colorado','Atlanta'];
const quickLinks = [
  { label: 'About REVIVE', id: 'about' },
  { label: 'Register', id: 'register' },
  { label: 'Volunteer', id: 'get-involved' },
  { label: 'Partner / Give', id: 'get-involved' },
  { label: 'Prayer Wall', id: 'prayer' },
  { label: 'Media', id: 'media' },
  { label: 'Merch', id: 'merch' },
  { label: 'FAQ', id: 'faq' },
];

const linkStyle = { fontSize: 13, color: 'rgba(245,240,232,0.4)', textDecoration: 'none', letterSpacing: '0.05em', background: 'none', border: 'none', textAlign: 'left', padding: 0, display: 'block', marginBottom: 12, transition: 'color 0.3s', fontFamily: 'var(--font-body)' };

export default function Footer() {
  return (
    <footer style={{ background: '#030303', padding: '80px 64px 48px', borderTop: '1px solid rgba(200,68,10,0.15)' }}>
      <style>{`
        @media(max-width:900px){ footer{padding:60px 24px 40px!important;} .footer-grid{grid-template-columns:1fr 1fr!important; gap:40px!important;} }
        @media(max-width:480px){ .footer-grid{grid-template-columns:1fr!important;} }
        .footer-link:hover { color: var(--white) !important; }
      `}</style>

      <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 64, marginBottom: 64 }}>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 52, letterSpacing: '0.08em', color: 'var(--white)', marginBottom: 20 }}>
            REVIVE<span style={{ color: 'var(--ember)' }}>.</span>
          </div>
          <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 16, color: 'rgba(245,240,232,0.35)', lineHeight: 1.75, maxWidth: 260, marginBottom: 28 }}>
            A generation awakened. A city transformed. Eight cities. One mission.
          </p>
          <div style={{ display: 'flex', gap: 16 }}>
            {['Instagram','TikTok','YouTube','Facebook'].map(s => (
              <a key={s} href="#" style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.25)', textDecoration: 'none', transition: 'color 0.3s' }}
                onMouseEnter={e => e.target.style.color = 'var(--ember)'}
                onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.25)'}>
                {s}
              </a>
            ))}
          </div>
        </div>

        <div>
          <p style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 24 }}>Cities</p>
          {cityLinks.map(c => (
            <button key={c} className="footer-link" onClick={() => scrollTo('cities')}
              style={linkStyle}>
              REVIVE {c}
            </button>
          ))}
        </div>

        <div>
          <p style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 24 }}>Quick Links</p>
          {quickLinks.map(l => (
            <button key={l.label} className="footer-link" onClick={() => scrollTo(l.id)}
              style={linkStyle}>
              {l.label}
            </button>
          ))}
        </div>

        <div>
          <p style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 24 }}>Contact</p>
          <a href="mailto:hello@revivecities.com" className="footer-link" style={linkStyle}
            onMouseEnter={e => e.target.style.color = 'var(--white)'}
            onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.4)'}>
            hello@revivecities.com
          </a>
          <a href="#" className="footer-link" style={linkStyle}
            onMouseEnter={e => e.target.style.color = 'var(--white)'}
            onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.4)'}>
            @revivecities
          </a>
          <button className="footer-link" onClick={() => scrollTo('get-involved')} style={linkStyle}
            onMouseEnter={e => e.target.style.color = 'var(--white)'}
            onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.4)'}>
            Ministry Partners
          </button>
          <button className="footer-link" onClick={() => scrollTo('get-involved')} style={linkStyle}
            onMouseEnter={e => e.target.style.color = 'var(--white)'}
            onMouseLeave={e => e.target.style.color = 'rgba(245,240,232,0.4)'}>
            Media Inquiries
          </button>
          <div style={{ marginTop: 24, padding: '16px 20px', border: '1px solid rgba(212,168,67,0.2)', background: 'rgba(212,168,67,0.04)' }}>
            <p style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 6 }}>Give via Zelle</p>
            <p style={{ fontSize: 13, color: 'rgba(245,240,232,0.5)', wordBreak: 'break-all' }}>gc.boundlessgroup@gmail.com</p>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 32, borderTop: '1px solid rgba(245,240,232,0.06)', flexWrap: 'wrap', gap: 12 }}>
        <p style={{ fontSize: 11, color: 'rgba(245,240,232,0.18)', letterSpacing: '0.08em' }}>© 2026 REVIVE Campaign. All rights reserved.</p>
        <p style={{ fontSize: 11, color: 'rgba(245,240,232,0.18)', letterSpacing: '0.08em' }}>A generation awakened. A city transformed.</p>
      </div>
    </footer>
  );
}
